module.exports = __webpack_public_path__ + "static/img/cloud25.407f15ba.png";